<template>

  <svg
    t="1640066761897"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7282"
    width="64"
    height="64"
  ><path d="M239.9525 784.0475H123.362A38.862 38.862 0 0 1 84.5 745.181V123.362A38.862 38.862 0 0 1 123.362 84.5h621.819a38.862 38.862 0 0 1 38.8665 38.862v116.595h116.5905A38.862 38.862 0 0 1 939.5 278.8145v621.819a38.862 38.862 0 0 1-38.862 38.862H278.819a38.862 38.862 0 0 1-38.8665-38.862v-116.595z m466.3665-544.095V162.2285H162.224v544.0905h77.7285v-427.5a38.862 38.862 0 0 1 38.8665-38.8665h427.5zM317.681 317.681v544.095h544.095V317.6765H317.6765z" p-id="7283" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconWorkspace',
} as DefineComponent
</script>